var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import 'antd/lib/select/style/index.css';
import InputCategory from './InputCategory';
import FormAthleteScoreItem from './FormAthleteScoreItem';
var FormAthleteScore = (function (_super) {
    __extends(FormAthleteScore, _super);
    function FormAthleteScore(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.props.athleteDoc
            ? _this.filterData(props, _this.props.athleteDoc.categoryId)
            : {};
        _this.filterData = _this.filterData.bind(_this);
        _this.handleSetCategory = _this.handleSetCategory.bind(_this);
        return _this;
    }
    FormAthleteScore.prototype.filterData = function (props, categoryId) {
        var _this = this;
        var category = this.props.categories.find(function (c) { return c.id === categoryId; });
        var rounds = this.props.rounds
            .filter(function (r) { return r.categoryId === categoryId; })
            .sort(function (a, b) { return a.index - b.index; });
        var athleteScores = !this.props.athleteScoreDocs || this.props.athleteScoreDocs.length === 0
            ? [{
                    roundId: rounds[0].id,
                    scoreSystem: rounds[0].scoreSystem,
                }]
            : rounds.reduce(function (accumulator, r) {
                var athleteScore = _this.props.athleteScoreDocs && _this.props.athleteScoreDocs.find(function (s) { return s.roundId === r.id; });
                if (athleteScore) {
                    accumulator.push(athleteScore);
                }
                return accumulator;
            }, []);
        return {
            category: category,
            rounds: rounds,
            athleteScores: athleteScores,
        };
    };
    FormAthleteScore.prototype.handleSetCategory = function (categoryId) {
        this.setState(this.filterData(this.props, categoryId));
    };
    FormAthleteScore.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        var athlete = this.props.athleteDoc;
        var rounds = this.state.rounds;
        var athleteScores = this.state.athleteScores;
        var isDisabled = this.props.isDisabled;
        return (React.createElement(React.Fragment, null,
            React.createElement(InputCategory, { form: form, initialValue: athlete && athlete.categoryId, isDisabled: isDisabled, categories: this.props.categories, onChange: this.handleSetCategory }),
            React.createElement(Divider, null),
            rounds &&
                athleteScores &&
                athleteScores.map(function (athleteScoreDoc, i) { return (React.createElement(FormAthleteScoreItem, { key: athleteScoreDoc.id || athleteScoreDoc.roundId, form: form, athleteScoreDoc: athleteScoreDoc, round: rounds[i], index: i, isDisabled: isDisabled, checkBibNumberIsUnique: _this.props.checkBibNumberIsUnique })); })));
    };
    return FormAthleteScore;
}(React.Component));
export default FormAthleteScore;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthleteScore/index.tsx
// module id = 1207
// module chunks = 0